(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customers-login"]) return;
  try {
    
(function() {
  /* Password show/hide */
  var pwInput = document.getElementById('cl-password');
  var pwBtn   = document.getElementById('cl-pw-btn');
  var eyeShow = document.getElementById('cl-eye-show');
  var eyeHide = document.getElementById('cl-eye-hide');

  if (pwBtn && pwInput) {
    pwBtn.addEventListener('click', function() {
      var isPass = pwInput.type === 'password';
      pwInput.type = isPass ? 'text' : 'password';
      eyeShow.style.display = isPass ? 'none' : '';
      eyeHide.style.display = isPass ? '' : 'none';
    });
  }

  /* Forgot password toggle */
  var forgotLink   = document.querySelector('.cl-forgot-row a');
  var loginForm    = document.querySelector('.shopify-challenge__container, form[action*="login"]');
  var recoverForm  = document.getElementById('cl-recover-form');
  var backBtn      = document.getElementById('cl-back-btn');

  if (forgotLink && recoverForm) {
    forgotLink.addEventListener('click', function(e) {
      e.preventDefault();
      if (loginForm) loginForm.style.display = 'none';
      var forgotRow = document.querySelector('.cl-forgot-row');
      var submitBtn = document.querySelector('.cl-btn-submit');
      if (forgotRow) forgotRow.style.display = 'none';
      if (submitBtn) submitBtn.style.display = 'none';
      recoverForm.style.display = '';
    });
  }

  if (backBtn && recoverForm) {
    backBtn.addEventListener('click', function() {
      recoverForm.style.display = 'none';
      var forgotRow = document.querySelector('.cl-forgot-row');
      var submitBtn = document.querySelector('.cl-btn-submit');
      if (loginForm) loginForm.style.display = '';
      if (forgotRow) forgotRow.style.display = '';
      if (submitBtn) submitBtn.style.display = '';
    });
  }

  /* Show recover form if URL has #recover hash */
  if (window.location.hash === '#recover') {
    var fr = document.getElementById('cl-recover-form');
    if (fr) fr.style.display = '';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-video"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var sid     = '{{ section.id }}';
  var section = document.getElementById('pv-' + sid);
  if (!section) return;

  var bg          = document.getElementById('pv-bg-' + sid);
  var content     = document.getElementById('pv-content-' + sid);
  var vidType     = section.getAttribute('data-pv-type');
  var doParallax  = section.getAttribute('data-pv-parallax') !== 'false';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Parallax on scroll ── */
  if (doParallax && bg && !prefersReduced) {
    function onScroll() {
      var rect   = section.getBoundingClientRect();
      var vh     = window.innerHeight;
      var ratio  = (vh - rect.top) / (vh + rect.height);
      var offset = (ratio - 0.5) * 80;
      bg.style.transform = 'translateY(' + offset + 'px)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Content animates via CSS keyframes — no JS needed */

  /* ── Self-hosted video controls ── */
  if (vidType === 'hosted' || vidType === 'mp4') {
    var video    = document.getElementById('pv-vid-' + sid);
    var muteBtn  = document.getElementById('pv-mute-' + sid);
    var playBtn  = document.getElementById('pv-play-' + sid);
    var iconMuted = document.getElementById('pv-icon-muted-' + sid);
    var iconSound = document.getElementById('pv-icon-sound-' + sid);
    var iconPause = document.getElementById('pv-icon-pause-' + sid);
    var iconPlay  = document.getElementById('pv-icon-play-' + sid);

    if (muteBtn && video) {
      muteBtn.addEventListener('click', function() {
        video.muted = !video.muted;
        if (iconMuted) iconMuted.style.display = video.muted ? '' : 'none';
        if (iconSound) iconSound.style.display = video.muted ? 'none' : '';
      });
    }

    if (playBtn && video) {
      playBtn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          if (iconPause) iconPause.style.display = '';
          if (iconPlay)  iconPlay.style.display  = 'none';
        } else {
          video.pause();
          if (iconPause) iconPause.style.display = 'none';
          if (iconPlay)  iconPlay.style.display  = '';
        }
      });
    }

    /* Pause when out of viewport — save battery */
    if (video) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (section.getAttribute('data-pv-autoplay') !== 'false') video.play().catch(function(){});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.2 });
      observer.observe(section);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

// --- Mouse wheel zoom state (shared across every gallery open) ---
var activeGallery = null;
var pswpWheelZoomLevel = null;

var resetPswpWheelZoom = function() {
  if (activeGallery && activeGallery.currItem) {
    pswpWheelZoomLevel = activeGallery.currItem.initialZoomLevel;
  }
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 20,
    getDoubleTapZoom: function(isMouseClick, item) {
      return item.initialZoomLevel * 4;
    },
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();

  activeGallery = gallery;
  gallery.listen('afterChange', resetPswpWheelZoom);
  gallery.listen('firstUpdate', resetPswpWheelZoom);
  resetPswpWheelZoom();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}

// --- Mouse wheel zoom: scroll up to zoom in, scroll down to zoom out ---
var pswpElementForWheel = document.querySelectorAll('.pswp')[0];
if (pswpElementForWheel) {
  pswpElementForWheel.addEventListener('wheel', function(e) {
    if (!activeGallery || !activeGallery.currItem) {
      return;
    }
    e.preventDefault();

    var minZoom = activeGallery.currItem.initialZoomLevel;
    var maxZoom = minZoom * 50;
    var step = minZoom * 0.35;

    if (pswpWheelZoomLevel === null) {
      pswpWheelZoomLevel = minZoom;
    }

    if (e.deltaY < 0) {
      pswpWheelZoomLevel = Math.min(maxZoom, pswpWheelZoomLevel + step);
    } else {
      pswpWheelZoomLevel = Math.max(minZoom, pswpWheelZoomLevel - step);
    }

    activeGallery.zoomTo(pswpWheelZoomLevel, { x: e.pageX, y: e.pageY }, 200);
  }, { passive: false });
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
